import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	issueAnalysis: {
		id: 'spa-apps-sidebar-core.controllers.default-report-items.issue-analysis',
		defaultMessage: 'Issue analysis',
		description: 'Title for issue analysis reports section',
	},
	averageAgeReport: {
		id: 'spa-apps-sidebar-core.controllers.default-report-items.average-age-report',
		defaultMessage: 'Average Age Report',
		description: 'Average age report link item',
	},
	createdResolvedIssuesReport: {
		id: 'spa-apps-sidebar-core.controllers.default-report-items.created-resolved-issues-report',
		defaultMessage: 'Created vs Resolved Issues Report',
		description: 'Created vs resolved issues report link item',
	},
	pieChart: {
		id: 'spa-apps-sidebar-core.controllers.default-report-items.pie-chart',
		defaultMessage: 'Pie Chart Report',
		description: 'Pie chart link item',
	},
	recentlyCreatedIssues: {
		id: 'spa-apps-sidebar-core.controllers.default-report-items.recently-created-issues',
		defaultMessage: 'Recently Created Issues Report',
		description: 'Recently created issues link item',
	},
	resolutionTime: {
		id: 'spa-apps-sidebar-core.controllers.default-report-items.resolution-time',
		defaultMessage: 'Resolution Time Report',
		description: 'Resolution time report link item',
	},
	singleLevelGroup: {
		id: 'spa-apps-sidebar-core.controllers.default-report-items.single-level-group',
		defaultMessage: 'Single Level Group By Report',
		description: 'Single level group by report link item',
	},
	timeSinceIssues: {
		id: 'spa-apps-sidebar-core.controllers.default-report-items.time-since-issues',
		defaultMessage: 'Time Since Issues Report',
		description: 'Time since issues link item',
	},
	issueAnalysisIssueTermRefresh: {
		id: 'spa-apps-sidebar-core.controllers.default-report-items.issue-analysis-issue-term-refresh',
		defaultMessage: 'Work item analysis',
		description: 'Title for issue analysis reports section',
	},
	createdResolvedIssuesReportIssueTermRefresh: {
		id: 'spa-apps-sidebar-core.controllers.default-report-items.created-resolved-issues-report-issue-term-refresh',
		defaultMessage: 'Created vs resolved work items report',
		description: 'Created vs resolved issues report link item',
	},
	recentlyCreatedIssuesIssueTermRefresh: {
		id: 'spa-apps-sidebar-core.controllers.default-report-items.recently-created-issues-issue-term-refresh',
		defaultMessage: 'Recently created work items report',
		description: 'Recently created issues link item',
	},
	timeSinceIssuesIssueTermRefresh: {
		id: 'spa-apps-sidebar-core.controllers.default-report-items.time-since-issues-issue-term-refresh',
		defaultMessage: 'Time since work items report',
		description: 'Time since issues link item',
	},
});
